import React, { PropTypes, Component } from "react"
import { disposeFilename } from "app/vendor/util"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import "./flexableFileName.scss"
import { Row } from "antd"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { getCurrentApp } from "app/api/localTools"
import cx from "classnames"

export default class Index extends Component {
  renderFileName = (text) => {
    const { matched, isEqual } = this.props
    const app = getCurrentApp()
    switch (app) {
      case 'pgs':
        return (
          <span style={{ color: !isEqual ? 'red' : 'unset' }}>{text}</span>
        )
      case 'pgd':
        return (
          <span style={{ color: !matched ? 'red' : 'unset' }}>{text}</span>
        )
      default:
        return (
          <span>{text}</span>
        )
    }
  }
  render() {
    const { filename, className, children, wordWrap, highlight = true, keywords, _filename } = this.props
    let highlightShowed
    const app = getCurrentApp()
    const { front, end } = disposeFilename(filename)
    if (app === 'pgs') {
      highlightShowed = highlight && highlightable(filename, _filename)
    } else {
      highlightShowed = highlight && highlightable(filename, keywords)
    }
    let styles = cx({
      "filename-front": true,
      "ellipsis": !wordWrap,
    })
    return (
      <MaterialTip
        overlayClassName="ellipsis-tip"
        title={filename}>
        {wordWrap ?
          <Row className={className + " filename-wrapper filename"} type="flex">
            {this.renderFileName(filename)}
          </Row> :
          <Row className={className + " filename-wrapper filename"} type="flex">
            {/* <div className={styles}>
              {highlightShowed ?
                (<Highlighter
                  highlightClassName="lightlight"
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={[front]}
                  textToHighlight={front}
                />) :
                this.renderFileName(front)
              }
            </div>
            <div className="filename-end">
              {highlightShowed ?
                (<Highlighter
                  highlightClassName="lightlight"
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={[end]}
                  textToHighlight={end}
                />) :
                this.renderFileName(end)
              }
            </div> */}
             <div className={styles}>
              {highlightShowed ?
                (<Highlighter
                  highlightClassName="lightlight"
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={[front]}
                  textToHighlight={front}
                />) :
                this.renderFileName(front)
              }
              {highlightShowed ?
                (<Highlighter
                  highlightClassName="lightlight"
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={[end]}
                  textToHighlight={end}
                />) :
                this.renderFileName(end)
              }
            </div>
            {children}
          </Row>
        }
      </MaterialTip >
    )
  }
}

Index.propTypes = {
  filename: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/app/components/normal/FlexableFileName/index.js